// @ts-check
import LocalStorageService from '@bto-services/storage/local-storage-service';

export const USER_BETSLIPS_STORAGE_KEY = 'user-betslips-rebet';

/**
 * @typedef {import('bto-models/betslip/interfaces').BetslipStore} BetslipStore 
 */

/**
 * Get default/saved state from local storage
 * @param {{[userId_identifier:string]: BetslipStore & {placeTime:number}}} savedState - map of userId_identifier: BetslipStore
 * @returns default state plus saved state
 */
const getSavedState = (savedState) => ({
  ...savedState,
});

const savedToastNotificationStore = LocalStorageService.get(USER_BETSLIPS_STORAGE_KEY) || {};

export const userBetslipsStore = getSavedState(savedToastNotificationStore);

/**
 * Function to save toast state to localstorage
 */
export const saveUserBetslipsStore = () => {
  LocalStorageService.set(USER_BETSLIPS_STORAGE_KEY, userBetslipsStore);
};